import PropTypes from "prop-types";
import { Box, Table } from "@mui/material";

export default function AdminTableScrollLayout({
  containerSx,
  tableMinWidth,
  head,
  body,
  headTableSx = {},
  bodyTableSx = {},
  size,
  bodyMaxHeight,
}) {
  const tableSizeProps = size ? { size } : {};
  const scrollBoxSx = {
    width: "100%",
    minWidth: 0,
    overflow: "auto",
    WebkitOverflowScrolling: "touch",
    ...(bodyMaxHeight
      ? { maxHeight: bodyMaxHeight, flexShrink: 0 }
      : { flex: 1, minHeight: 0 }),
  };

  const tableSx = {
    width: "100%",
    tableLayout: "auto",
    borderCollapse: "separate",
    borderSpacing: 0,
    ...(tableMinWidth != null && tableMinWidth !== "" ? { minWidth: tableMinWidth } : {}),
    ...headTableSx,
    ...(bodyTableSx && Object.keys(bodyTableSx).length > 0
      ? { "& .MuiTableBody-root": bodyTableSx }
      : {}),
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: 0, minWidth: 0, overflow: "hidden", ...containerSx }}>
      <Box sx={scrollBoxSx}>
        <Table stickyHeader sx={tableSx} {...tableSizeProps}>
          {head}
          {body}
        </Table>
      </Box>
    </Box>
  );
}

AdminTableScrollLayout.propTypes = {
  containerSx: PropTypes.object,
  tableMinWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  head: PropTypes.node.isRequired,
  body: PropTypes.node.isRequired,
  headTableSx: PropTypes.object,
  bodyTableSx: PropTypes.object,
  size: PropTypes.string,
  bodyMaxHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};
 